// Punto único de captura de leads del funnel (VSL + los 3 lead magnets).
//
// Junta las tres cosas que antes estaban repetidas y desalineadas en cada página:
// 1. Dispara el Pixel SIEMPRE, con un eventID compartido con el CAPI del servidor.
// 2. Manda las señales de Meta (_fbp, _fbc, fbclid) para que la conversión se
//    atribuya a la campaña.
// 3. Reintenta el envío si el backend no responde, en vez de perder el lead.

import { getOrCreateAnonymousId } from './anonymousId';
import { getAttributionPayload } from './attribution';
import { getMetaSignals, newEventId } from './metaCookies';
import { sendLeadWithRetry } from './leadQueue';
import { trackVideoAccessLead } from './metaPixel';

const LEAD_ENDPOINT = '/api/video-lead';

/**
 * @param {object} params
 * @param {object} params.data    - { nombre, email, whatsapp, instagram } del formulario
 * @param {string} [params.source] - 'calorie-macro-calculator' | '5-day-split' | 'sleep-guide' | 'blood-work'.
 *                                   Vacío = lead del VSL de la home.
 * @returns {Promise<boolean>} true si el backend confirmó el guardado
 */
export async function submitLead({ data, source }) {
  const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
  const eventId = newEventId('lead');

  // El Pixel va antes del fetch y sin condicionarlo a la respuesta: la persona ya
  // entregó sus datos, la conversión es real aunque nuestro guardado falle.
  trackVideoAccessLead(eventId, source);

  return sendLeadWithRetry(backendUrl, LEAD_ENDPOINT, {
    ...data,
    ...(source ? { source } : {}),
    anonymous_id: getOrCreateAnonymousId(),
    tracking: getAttributionPayload(),
    event_id: eventId,
    source_url: typeof window !== 'undefined' ? window.location.href : '',
    ...getMetaSignals(),
  });
}
